import { getApplicationInstance } from '../../../core/app';

import { shallowRef, onUnmounted } from 'vue';
import { useObservableSubscriber } from 'capo-mvvm-vue/composables/observable';

const app = getApplicationInstance();

export function useCragModel() {
    return useObservableSubscriber(app.crag);
}

export function useBoulderModel() {
    return useObservableSubscriber(app.boulder);
}

export function useLineModel() {
    return useObservableSubscriber(app.line);
}

